import React, { useState } from "react";
import "../ComponentsCSS/Contact.css";
import SEO from "./SEO";

const BookingForm = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.target;
    fetch("https://formsubmit.co/ajax/admin@saskaoneshuttle.com", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(Object.fromEntries(new FormData(form)))
    })
      .then(response => {
        if (response.ok) {
          setSubmitted(true);
        } else {
          alert("Something went wrong. Please try again.");
        }
      })
      .catch(error => alert("Failed to send form"));
  };

  return (
    <>
      <SEO
        title="Contact Us | SASK A One Shuttle | Prince Albert"
        description="Get in touch with SASK A One Shuttle. Contact us for inquiries about local transport, long-distance travel, and specialized care transportation."
        keywords="contact Sask A One Shuttle, Prince Albert shuttle contact number, shuttle contact Saskatchewan"
      />
      <div className="container-fluid my-5 py-5 text-center contact-page" data-aos="slide-up">
        <h1 data-aos="zoom-in">Contact Us</h1>
        <p data-aos="zoom-in">Home / ContactUs</p>
      </div>

      {!submitted ? (
        <form onSubmit={handleSubmit} className="p-4 booking-form mt-5" data-aos="slide-up">
          <input type="hidden" name="_subject" value="New Shuttle Booking Request" />
          <input type="hidden" name="_template" value="box" />
          <input type="hidden" name="_captcha" value="false" />

          <input name="First Name" placeholder="First Name" required className="form-control mb-3" />
          <input name="Last Name" placeholder="Last Name" required className="form-control mb-3" />
          <input type="email" name="Email" placeholder="E-Mail" required className="form-control mb-3" />
          <input name="Phone" placeholder="Phone Number" required className="form-control mb-3" />
          <input name="Persons" placeholder="Numbers of Persons" required className="form-control mb-3" />
          <input name="Pick Up" placeholder="Pick Up" required className="form-control mb-3" />
          <input name="Destination" placeholder="Destination" required className="form-control mb-3" />
          <input type="date" name="Date" required className="form-control mb-3" />
          <input type="time" name="Time" required className="form-control mb-3" />
          <input name="Luggage" placeholder="Number of Luggage" required className="form-control mb-3" />
          <select name="Vehicle" required className="form-control mb-3">
            <option value="">Select Vehicle...</option>
            <option value="Any">Any</option>
            <option value="Van">Van</option>
            <option value="Wheelchair Van">Wheelchair Van</option>
          </select>
          <textarea name="Instructions" placeholder="Instructions for the Driver" className="form-control mb-3" />
          <button type="submit" className="btn btn-primary w-100">Send Inquiry</button>
        </form>
      ) : (
        <div className="text-center mt-5">
          <h2>✅ Your booking is done!</h2>
          <p>Thank you! We’ve received your request.</p>
        </div>
      )}
    </>
  );
};

export default BookingForm;
